module.exports = __webpack_public_path__ + "img/sillon.6a62e5c3.svg";